import { makeStyles } from "@material-ui/styles";

const useChartEditorStyles = makeStyles({
  selectedChart: {
    boxShadow: "0px 0px 8px rgb(0,100,216)",
    color: "#222",
  },
  chartIconsContainer: { display: "flex", width: "100%", gap: "10px" },
  container: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    marginBottom: "20px",
  },
  contentContainer: {
    width: "91.2%",
    display: "flex",
    flexDirection: "column",
    alignItems: "start",
    justifyContent: "center",
  },
  title: {
    color: "grey",
  },
  controlsContainer: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    backgroundColor: "#EEEEF3",
    borderRadius: "10px",
    padding: "14px",
    alignItems: "start",
  },
  header: {
    width: "100%",
    display: "flex",
    alignItems: "center",
    height: "24px",
    justifyContent: "space-between",
    marginBottom: "10px",
  },

  whiteContainer: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "start",
    justifyContent: "center",
    backgroundColor: "rgba(255, 255, 255, 0.8)",
    borderRadius: "6px",
    padding: "7px",
  },
});

export default useChartEditorStyles;
